import { apiRequest } from "./client";
import { z } from "zod";
import type {
  ImportRecipientsResult,
  RecipientRecord,
  RecipientStatus,
  RecipientStatusChange,
  RecipientStatusRequest,
} from "@kkp/api-client";

import { parseListItems, wireInt } from "./parse";

const RecipientRecordSchema = z.object({
  seqId: wireInt,
  fullName: z.string(),
  employeeId: z.string(),
  ktpId: z.string(),
  npwpId: z.string(),
  bankName: z.string(),
  bankCode: z.string(),
  bankAccount: z.string(),
  phone: z.string().nullable(),
  totalReceivedCount: wireInt,
  totalReceivedAmount: z.string(),
  status: z.enum(["Active", "Inactive"]),
}) satisfies z.ZodType<RecipientRecord>;

export type { ImportRecipientsResult };

export async function listRecipients(): Promise<RecipientRecord[]> {
  const data = await apiRequest<unknown>({
    path: "/recipients",
    method: "GET",
  });

  return parseListItems(RecipientRecordSchema, data, "recipients");
}

export async function downloadRecipientTemplate(): Promise<string> {
  return apiRequest<string>({
    path: "/recipients/template",
    method: "GET",
  });
}

export async function importRecipients(
  file: File,
): Promise<ImportRecipientsResult> {
  const body = new FormData();
  body.append("file", file);

  return apiRequest<ImportRecipientsResult, FormData>({
    path: "/recipients/import",
    method: "POST",
    body,
  });
}

export async function updateRecipientStatus(
  seqId: string,
  status: RecipientStatus,
): Promise<void> {
  await apiRequest<RecipientStatusChange, RecipientStatusRequest>({
    path: `/recipients/${seqId}/status`,
    method: "PATCH",
    body: { status },
  });
}
